// ==================== PlannedLeaves.jsx ====================
import React, { useEffect, useState } from "react";
import "../Styling/PlannedLeaves.css";
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import { CalendarDays } from "lucide-react";

const PlannedLeaves = ({ filters }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  // ✅ prefer filters, fallback to logged-in user
  const orgId = filters?.orgId || user?.organisationId;
  const companyCode = filters?.companyCode || user?.companyCode || "";
  const fiscalYear = filters?.fiscalYear || "All Fiscal Years";

  const [leaves, setLeaves] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!orgId) return;

    const fetchLeaves = async () => {
      try {
        setLoading(true);

        const params = new URLSearchParams();

        // future-ready
        if (companyCode) params.append("companyCode", companyCode);
        if (fiscalYear && fiscalYear !== "All Fiscal Years") {
          params.append("fiscalYear", fiscalYear);
        }

        const res = await fetch(
          `${Base_URL}/Leave/GetLeavesForNext10Days/${orgId}?${params.toString()}`
        );

        const data = await res.json();
        setLeaves(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("❌ Planned leaves error:", err);
        setLeaves([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaves();
  }, [orgId, companyCode, fiscalYear]); // 🔥 filter-driven

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
    });

  return (
    <div className="planned-leaves-card">
      <div className="planned-header">
        <div className="header-left">
          <div className="planned-icon">
            <CalendarDays size={18} />
          </div>
          <h6>Planned Leaves</h6>
        </div>

        <span
          className="view-all-tag"
          onClick={() => navigate("/view-leaves")}
        >
          View all
        </span>
      </div>

      {loading && (
        <p className="no-leaves text-muted">Loading upcoming leaves…</p>
      )}

      {!loading && leaves.length === 0 && (
        <p className="no-leaves">No upcoming leaves</p>
      )}

      {!loading &&
        leaves.slice(0, 4).map((item, idx) => (
          <div className="leave-row" key={idx}>
            <div className="leave-date">
              {formatDate(item.leaveDate)}
            </div>

            <div className="leave-info">
              <div className="name">{item.resource}</div>
              <div className="dept">{item.department}</div>
            </div>

            <span className="leave-type">{item.leaveType}</span>
          </div>
        ))}
    </div>
  );
};

export default PlannedLeaves;
